<div class="current-step-{{currentStep}}">
    <div class="step-1" *ngIf="currentStep === 1">

        <div class="upload-wrapper">
            <ns-my-documents-file-upload
                    [formGroup]="form"
            ></ns-my-documents-file-upload>
        </div>


        <h2>Dodaj dokumenty do biblioteki</h2>
    </div>

    <div class="step-2" *ngIf="currentStep === 2">
        <div class="" [formGroup]="form">
            <h2>{{ fileName }}</h2>

            <input kendoTextBox formControlName="name" placeholder="Podaj nazwę dla pliku">
            <cmn-errors [control]="form.get('name')"></cmn-errors>

            <br>
            <button kendoButton [primary]="true" class="big" (click)="saveFile()">
                <span class="item-icon documents-white"></span>
                Dodaj do biblioteki
            </button>
            <br>
            <button kendoButton class="mid cancel" (click)="step1()">
                Anuluj
            </button>
        </div>
    </div>
</div>
